import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyRegistry } from './currency-registry';
import { DecimalPipe } from './decimal.pipe';

@Pipe({
	name: 'currencyDashboard'
})
export class CurrencyDashboardPipe implements PipeTransform {

	static transform(value: any, currency: string, thousandSeparator: boolean = true): any {
		const meta = CurrencyRegistry.get(currency);
		const p = meta.dashboard_precision;
		const number = DecimalPipe.transform(value, p, p, thousandSeparator);
		return CurrencyRegistry.applyAffix(meta, number);
	}

	transform(value: any, currency: string, thousandSeparator: boolean = true): any {
		return CurrencyDashboardPipe.transform(value, currency, thousandSeparator);
	}

}
